// extracted by mini-css-extract-plugin
module.exports = {"TimeTicker":"TimeTicker_TimeTicker__21tW6"};